var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[(_vm.showToolbar)?_c('app-toolbar'):_vm._e(),(_vm.showNavigationDrawer)?_c('navigation-drawer'):_vm._e(),_c('v-content',[_c('router-view')],1),_c('app-snackbar',{ref:"snackbar"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }